import React from 'react';
import { Popover } from '@stockx/ui';
import { useIsNonInteractiveViewer } from '@app/ui';
import type { PopoverProps } from '@chakra-ui/popover';
import { Container, staticContainerStyles } from './DropdownContainer.styles';

const DropdownContainer = ({ children }: PopoverProps) => {
  const isNonInteractiveViewer = useIsNonInteractiveViewer();

  return (
    <Container sx={isNonInteractiveViewer ? staticContainerStyles : undefined}>
      <Popover
        trigger="hover"
        placement="bottom-end"
        openDelay={0}
        closeDelay={0}
        offset={[0, 1]}
        isOpen={isNonInteractiveViewer || undefined}
      >
        {children}
      </Popover>
    </Container>
  );
};

export default DropdownContainer;
